import type { Facets } from '@iheartjane/dm-sdk';
import type { Nullable } from '@iheartjane/types';

const storageNamespace = 'janePremium/filters';

export const get = (): Nullable<Facets> => {
  try {
    const stored = window.localStorage.getItem(storageNamespace);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const set = (value: Facets) => {
  try {
    window.localStorage.setItem(storageNamespace, JSON.stringify(value));
  } catch {
    return;
  }
};

export const reset = () => {
  try {
    window.localStorage.removeItem(storageNamespace);
  } catch {
    return;
  }
};
